/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export var ViewClassDependency = (function () {
    /**
     * @param {?} comp
     * @param {?} name
     * @param {?} placeholder
     */
    function ViewClassDependency(comp, name, placeholder) {
        this.comp = comp;
        this.name = name;
        this.placeholder = placeholder;
    }
    return ViewClassDependency;
}());
function ViewClassDependency_tsickle_Closure_declarations() {
    /** @type {?} */
    ViewClassDependency.prototype.comp;
    /** @type {?} */
    ViewClassDependency.prototype.name;
    /** @type {?} */
    ViewClassDependency.prototype.placeholder;
}
export var ComponentFactoryDependency = (function () {
    /**
     * @param {?} comp
     * @param {?} placeholder
     */
    function ComponentFactoryDependency(comp, placeholder) {
        this.comp = comp;
        this.placeholder = placeholder;
    }
    return ComponentFactoryDependency;
}());
function ComponentFactoryDependency_tsickle_Closure_declarations() {
    /** @type {?} */
    ComponentFactoryDependency.prototype.comp;
    /** @type {?} */
    ComponentFactoryDependency.prototype.placeholder;
}
export var DirectiveWrapperDependency = (function () {
    /**
     * @param {?} dir
     * @param {?} name
     * @param {?} placeholder
     */
    function DirectiveWrapperDependency(dir, name, placeholder) {
        this.dir = dir;
        this.name = name;
        this.placeholder = placeholder;
    }
    return DirectiveWrapperDependency;
}());
function DirectiveWrapperDependency_tsickle_Closure_declarations() {
    /** @type {?} */
    DirectiveWrapperDependency.prototype.dir;
    /** @type {?} */
    DirectiveWrapperDependency.prototype.name;
    /** @type {?} */
    DirectiveWrapperDependency.prototype.placeholder;
}
//# sourceMappingURL=deps.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/compiler/src/view_compiler/deps.js
// module id = 239
// module chunks = 3